import { Dispatch } from "redux";
import { errorHandler } from "../../helpers/Functions";
import { Pagination } from "../../Interfaces/Interfaces";
import AggregatorService from "../../services/AggregatorService";
import WalletService from "../../services/WalletService";

export const getAggregators = (data: Pagination) => {
  const api = new AggregatorService().getAggregators(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "AGGREGATORS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const getAggregatoerByPhone = (phoneNumber: string) => {
  const api = new AggregatorService().getAggregatorByPhone(phoneNumber);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "AGGREGATOR_BY_PHONE_NUMBER",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const inviteAggregatorAction = (data: any) => {
  const api = new AggregatorService().inviteAggregatorService(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const onboardAggregatorAction = (data: any) => {
  const api = new AggregatorService().onboardAggregators(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const queryAggregators = (data: Pagination) => {
  const api = new AggregatorService().queryAggregators(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "AGGREGATORS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const getTradePartnerLocation = () => {
  const api = new AggregatorService().getTradePartnerLocation();

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "Trade_Partner_Location",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const getAggregatorDetails = (id: string) => {
  const api = new AggregatorService().getAggregatorDetails(id);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "AGENT_DETAILS",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: errorHandler(res),
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const getAggregatorAccount = (id: string) => {
  const api = new WalletService().getAggregatorAccount(id);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ACCOUNTS",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: errorHandler(res),
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const resetAggregatorPin = (data: any) => {
  const api = new AggregatorService().resetPin(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: errorHandler(res),
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const resetUserPersonnelPin = (data: any) => {
  const api = new AggregatorService().resetPin(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: errorHandler(res),
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAggregatoerByIdAction = (id: any) => {
  const api = new AggregatorService().getAggregatorById(id);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "GET_AGGREGATOR",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const acceptAggregatorInviteAction = (data: any) => {
  const api = new AggregatorService().acceptAggregatorInvite(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: errorHandler(res),
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
